export default __webpack_public_path__ + "static/media/Group_12507.ea7ad92b.svg";